// extracted by mini-css-extract-plugin
export var container = "styles-module--container--8fa2c";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var review = "styles-module--review--8ecad";
export var reviews = "styles-module--reviews--40470";
export var singleReview = "styles-module--singleReview--fd674";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var title = "styles-module--title--d71e5";